import React from 'react';
import styled from 'styled-components';
import { useTheme } from '../../context/ThemeContext';
import { getTheme } from '../../theme';
import Sidebar from './Sidebar';
import Header from './Header';

const LayoutContainer = styled.div`
  display: flex;
  min-height: 100vh;
  background-color: ${props => getTheme(props.theme?.isDark).colors.background};
`;

const MainContent = styled.main`
  margin-left: 260px;
  margin-top: 70px;
  padding: ${props => getTheme(props.theme?.isDark).spacing.lg};
  width: calc(100% - 260px);
  min-height: calc(100vh - 70px);
`;

const MainLayout = ({ children }) => {
  const { isDark } = useTheme();
  const theme = { isDark };

  return (
    <LayoutContainer theme={theme}>
      <Sidebar />
      <Header />
      <MainContent theme={theme}>
        {children}
      </MainContent>
    </LayoutContainer>
  );
};

export default MainLayout;

